import isEmpty from 'lodash.isempty';

export function createStatMarkupForArrays(heading, values) {
  if (isEmpty(values)) {
    return '';
  }

  return `
      <div class="stat-group">
        <p class="stat-group__label">${heading}</p>
        <p class="stat-group__desc">${values.join(', ')}</p>
      </div>
    `;
}

export function joinWithCommas(values) {
  return Array.isArray(values) ? values.join(', ') : values;
}

export function hasDatePassed(date) {
  return Date.now() > new Date(date);
}
